module.exports = __webpack_public_path__ + "img/mobile-pana.97e1cb09.svg";